module.exports = function (errorName) {
    return {
        errorMessage: errorName,
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/analytics/dtm/common-mappers/error-analytics-mapper.js